function Shop_catalog_filter(element) {
    this.$element = $(element);

    this.selectors = {
	    optionBox: '.js-option-box',
	    selectedLabel: '.js-selected',
	    selectedLabelInBox: '.js-selected-box',
    };
    
    this.modifiers = {
	    shown: 'c-shop-catalog__filter-item-option--shown'
    };
    
    this.init = function() {
   
	    this.$optionBox = this.$element.find(this.selectors.optionBox);
		this.$selectedLabel = this.$element.find(this.selectors.selectedLabel);
		this.$selectedLabelInBox = this.$element.find(this.selectors.selectedLabelInBox);
 
	    this.$selectedLabel.on('click', this.$onClickSelectedLabel.bind(this));
	    this.$selectedLabelInBox.on('click', this.$onClickSelectedLabelBox.bind(this));
	    
	    var index_click = i4_Document_listener.add('click', {
			exclude: [this.selectors.optionBox, this.selectors.selectedLabel],
		    callback: (function() {
		    	this.$optionBox.removeClass(this.modifiers.shown);		
		    }).bind(this)
		});
		i4_Document_listener.run();
	};

    
    this.$onClickSelectedLabel = function(event) {
	    event.preventDefault();
	    
	    this.$optionBox.addClass(this.modifiers.shown);
    };

    
    this.$onClickSelectedLabelBox = function(event) {
	    event.preventDefault();
	    
	    this.$optionBox.removeClass(this.modifiers.shown);
    };
}
